import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {ComponentFormatter, remoteOptionFormatter} from "../../../utils/formatters";
import Select from "../../form/Select";
import {componentFilter, optionFilter} from "../../../utils/filters";

class StoreOrderClaimList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "StoreOrderClaimList"}
                {...props}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    ...(
                        !this.props.client ? {
                            "client_component_type": {
                                header: 'Tevékenység',
                                width: 1,
                                sortable,
                                filterable: componentFilter({component: []}),
                                renderer: (value) => ComponentFormatter({component: value})

                            },
                            "client_component_id": {
                                header: 'Id',
                                width: 1,
                                sortable,
                                filterable
                            },
                            "client.partner.name": {
                                header: 'Partner',
                                width: 2,
                                sortable,
                                filterable
                            },
                            "client.origin.name": {
                                header: 'Honnan',
                                width: 2,
                                sortable,
                                filterable
                            },
                            "client.destination.name": {
                                header: 'Hova',
                                width: 2,
                                sortable,
                                filterable
                            },
                            "client.transaction_date": {
                                header: 'Tranzakció dátuma',
                                width: 2,
                                sortable,
                                filterable
                            },
                        } : {
                            
                        }
                    ),
                    "type": {
                        header: 'Típus',
                        width: 2,
                        sortable,
                        filterable: <Select
                            storeType="local"
                            options={[
                                {key: "-1", label: "Hiány"},
                                {key: "1", label: "Többlet"}
                            ]}
                            label={false}
                            objectValue={false}
                            isClearable={true}
                            valueKey="key"
                            labelKey="label"
                        />,
                        renderer: (value) => ({"-1": "Hiány","1": "Többlet"})[value]
                    },
                    "state": {
                        header: 'Státusz',
                        width: 2,
                        sortable,
                        filterable: optionFilter("StoreOrderClaimState"),
                        renderer: remoteOptionFormatter("StoreOrderClaimState")
                    },
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default StoreOrderClaimList;
